import React from "react";
import { Button, Typography } from "@mui/material";
import theme from '../LayoutComponents/theme';

function PurpleButton({ children, label, onClick, icon, onSubmit, type, disabled, color, size="medium" }) {

    const styles = {
    button: {
        backgroundColor: theme.colors[color] || theme.colors.purple,
        color: 'white',
        padding: '0.5rem 1rem',
        borderRadius: '5px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#8c4ca3', 
        },
        '&:active': {
            backgroundColor:'#8c4ca3',
        }
    }
};

    return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <Button  onClick={onClick} onSubmit={onSubmit} sx={styles.button} icon={icon} type={type} disabled={disabled} size={size}>
                <Typography variant="button" style={{ fontWeight: theme.typography.fontWeightBold }}>
                {label}
                </Typography>   
                {children}
            </Button>
        </div>
    );
}

export default PurpleButton;